import React, { useState } from "react";
import { Panel, PageLoading, PanelActions, PanelHeading, Button } from "@backslashbuild/pp-ui";
import FormField from "./FormField";
import { usePost, useGetNewAgencyFields } from "./api";
import { isTextNullOrEmpty } from "./utils";

export default function NewAgencyForm({ onClose }) {
  const [payload, storePayload] = useState({});
  const { data, loading, error } = useGetNewAgencyFields();
  const createAgency = usePost("create");

  if (loading) return <PageLoading />;

  function handleRender() {
    if (!isTextNullOrEmpty(error)) return <div>{String(error)}</div>;

    if (data != null && !data.isSuccess) {
      return data.errors.map((error) => <div>{error}</div>);
    }

    return data.value.map((field) => (
      <FormField key={field.key} field={field} onSave={getOnSaveHandler(field.key)} />
    ));
  }

  function getOnSaveHandler(key) {
    return (value) => {
      storePayload({ ...payload, [key]: value });
    };
  }

  return (
    <Panel>
      <PanelHeading>Create new agency</PanelHeading>
      {handleRender()}
      <PanelActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            createAgency({
              ...payload,
            }).then((res) => {
              if (!res?.isSuccess) {
                alert(res?.errors);
              } else {
                onClose();
              }
            });
          }}
        >
          Save
        </Button>
      </PanelActions>
    </Panel>
  );
}
